
import { useParams } from "react-router-dom";
import StatusSouscription from "features/darkweb/components/StatusSouscription";
import { useContext, useEffect, useState } from "react";
import { ID_TRACKER_PRICING, Pricing } from "shared/config/pricings";
import { StripePaymentCard } from "features/payment";
import { UserContext } from "features/account";
import DocumentIllustration from "components/DocumentIllustration";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Input from "shared/ui/Input";
import IndicatifPhone from "shared/ui/IndicatifPhone";
import Button from "shared/ui/Button";
import { Button_Style } from "shared/ui/Button/Button";
import ResultAfterPayment from "components/ResultAfterPayment";
import { checkEmail, register, resend } from "features/account";
import { User } from "shared/types/types";
import TermsAgreement from "components/TermsAgreement";
import Alert from "shared/ui/Alert";
import { generateRandomPassword, getOfferPlan } from "utils/utils";
import { useNavigate } from "react-router";
import { login } from "features/auth";
import Footer from "components/Footer";

interface IData {
    user?: User | null;
    chosenPlan?: Pricing | null;
    isNewUser?: boolean | null;
}

const SouscriptionPage = () => {
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const type = user?.type ?? 'individual'
    const [phonePrefix, setPhonePrefix] = useState("+33");
    const [message, setMessage] = useState("");
    const [title, setTitle] = useState("");
    const [paymentSucceeded, setPaymentSucceeded] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [isMonth, setIsMonth] = useState<boolean | undefined>(undefined);
    let { offer: offerId, offerHeadRoute, isMonthActive } = useParams(); // offreId
    const [datas, setDatas] = useState<IData>();

    const [isNewUser, setIsNewUser] = useState(true);
    const [generatedPassword, setGeneratedPassword] = useState("");

    const [steps, setSteps] = useState([
        { isCurrent: true, isDone: false }, // // STEP du champ Nom & prenom
        { isCurrent: false, isDone: false }, // STEP du champ email & confirmEmail & phoneNumber
        { isCurrent: false, isDone: false }, // STEP du paiment
        { isCurrent: false, isDone: false }, // STEP du Resultat du paiement
    ]);

    const [stepStatus, setStepStatus] = useState(0);

    useEffect(() => {
        let index = 1;
        try {
            index = parseInt(offerId!);
            if (index === 0) {
                index = 1;
            }
            if (isMonthActive === "1fois") {
                setIsMonth(undefined)
            } else {
                setIsMonth(isMonthActive === 'true')
            }
        } catch (e) {
            index = 1;
            setIsMonth(true)
        }
        setDatas({
            user: user,
            chosenPlan: getOfferPlan(offerHeadRoute, parseInt(offerId || "0")) ?? ID_TRACKER_PRICING[1],
            isNewUser: false,
        });
    }, [offerId, user?.id, isMonthActive]);

    useEffect(() => {
        if (user?.email !== undefined) {
            handleUpdateStep(steps?.length - 2 ?? 0); // Le step de paiement strip
        }
    }, [user?.email]);



    const handlePreviousStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep > 0) {
            handleUpdateStep(currentStep - 1);
        }
    };

    const handlePaymentResult = (title: string, message: string, paymentSucceeded: boolean) => {
        handleNextStep();
        setTitle(title);
        setMessage(message);
        setPaymentSucceeded(paymentSucceeded);
        if (paymentSucceeded) {

        }
    };

    const handleGoToProfile = async () => {
        if (!isNewUser) {
            if (user?.id) {
                navigate(`${type === 'individual' ?
                  '/particuliers/profil':
                  '/professionnels/profil'
                }`, { replace: true });
            } else {
                navigate('/particuliers/login', { replace: true });
            }
        } else {
            try {
                setIsLoading(true);
                const request: any = await login(datas?.user?.email, generatedPassword);
                setIsLoading(false);

                if (request.data?.type === "individual") {
                    navigate('/particuliers/profil', { replace: true });
                } else {
                    setErrorMessage(request.response.data.error);
                }
            } catch (error: any) {
                setIsLoading(false);
                if (error.request.response?.startsWith("<")) {
                    setErrorMessage("Le serveur est indisponible. Merci de réessayer plus tard.");
                } else {
                    const errorText = JSON.parse(error.request.response).error;
                    setErrorMessage(errorText);
                }
            }
        }
    }

    const handleUpdateStep = (step: number) => {
        setSteps(
            steps.map((s, index) => {
                if (index === step) {
                    return { isCurrent: true, isDone: false };
                } else if (index < step) {
                    return { isCurrent: false, isDone: true };
                }
                return { isCurrent: false, isDone: false };
            }),
        );

        setStepStatus(step);
    };

    const handleNextStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep < steps.length - 1) {
            handleUpdateStep(currentStep + 1);
        }
    };

    const checkEmailExistance = async (email?: string, phoneNumber?: string) => {
        if (email) {
            setIsLoading(true);
            setErrorMessage("");
            const response = await checkEmail(email);
            if (response?.success !== undefined) { // Si email n'est pas utilisé
                setIsNewUser(true);
                setDatas({...datas, isNewUser: true});
                await handleRegisterNewUser(email, phoneNumber);
            } else {
                setIsNewUser(false);
                handleNextStep();
            }
            setIsLoading(false);
        }
    };

    const handleRegisterNewUser = async (email?: string, phoneNumber?: string) => {
        try {
            const randomPassword = generateRandomPassword();
            setGeneratedPassword(randomPassword);
            await register({
                ...datas?.user,
                email,
                phoneNumber,
                type: 'individual',
                password: randomPassword,
                isNewUserBySubscriptionAutomaticLogin: true
            });
            handleNextStep();
            await resend(email, "p"); // On envoie un mail pour changer son mot de passe
        } catch(e) {
            setErrorMessage("Une erreur est survenue, veuillez réessayer");
        }
    }

    return (
        <>
            <div className="content__body">
                <StatusSouscription steps={stepStatus} handleUpdateStep={handleUpdateStep} />
                <div className="w-100 d-flex flex-row flex-wrap justify-content-center align-items-center gap-3 mb-2">
                    <div className="card center w-30 min-w-30">
                        {steps[0].isCurrent && (
                            <>
                                <div>
                                    <h3 className="text-center text-initial text-dark">
                                        Votre première <span className="text-uppercase text-primary">protection</span> est à portée de main.
                                    </h3>
                                    {
                                        <Formik
                                            initialValues={{
                                                firstname: datas?.user?.firstname || "",
                                                lastname: datas?.user?.lastname || "",
                                            }}
                                            validationSchema={Yup.object({
                                                firstname: Yup.string()
                                                    .min(2, "Le prénom doit contenir au moins 2 caractères.")
                                                    .max(50, "Le prénom ne peut pas dépasser 50 caractères.")
                                                    .matches(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s-]+$/, "Seules les lettres, les espaces et les tirets sont autorisés.")
                                                    .required("Le prénom est requis."),
                                                lastname: Yup.string()
                                                    .min(2, "Le nom doit contenir au moins 2 caractères.")
                                                    .max(20, "Le nom ne peut pas dépasser 20 caractères.")
                                                    .matches(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s-]+$/, "Seules les lettres, les espaces et les tirets sont autorisés.")
                                                    .required("Le nom est requis"),
                                            })}
                                            onSubmit={(values) => {
                                                setDatas({ ...datas, user: {...datas?.user,...values} });
                                                handleNextStep();
                                            }}>
                                            {(formik) => (
                                                <Form className="w-100 h-100 d-flex flex-column align-items-center justify-content-between">
                                                    <div>
                                                        <p className="mb-2">Renseignez vos informations personnelles</p>
                                                        <Input
                                                            onChange={formik.handleChange}
                                                            value={formik.values.lastname}
                                                            onBlur={formik.handleBlur}
                                                            required={true}
                                                            placeholder="Nom"
                                                            name="lastname"
                                                            type="text"
                                                            errorMessage={formik.touched.lastname && formik.errors.lastname ? formik.errors.lastname : ""}
                                                        />
                                                        <Input
                                                            onChange={formik.handleChange}
                                                            value={formik.values.firstname}
                                                            onBlur={formik.handleBlur}
                                                            required={true}
                                                            placeholder="Prénom"
                                                            name="firstname"
                                                            type="text"
                                                            errorMessage={formik.touched.firstname && formik.errors.firstname ? formik.errors.firstname : ""}
                                                        />

                                                        <div
                                                            className={`mt-1 d-flex justify-content-${!steps[0].isCurrent ? "between" : "center"} w-100`}>
                                                            {!steps[0].isCurrent && (
                                                                <Button
                                                                    label={"Retour"}
                                                                    onClick={() => handlePreviousStep()}
                                                                    style={Button_Style.OUTLINED}
                                                                />
                                                            )}
                                                            <Button
                                                                buttonType={"submit"}
                                                                label={"Suivant"}
                                                                disabled={!formik.isValid && formik.dirty}
                                                            />
                                                        </div>
                                                    </div>


                                                </Form>
                                            )}
                                        </Formik>
                                    }
                                    <TermsAgreement />
                                </div>
                            </>
                        )}

                        {steps[1].isCurrent && (
                            <>
                                <div>
                                    <h3 className="text-center text-initial text-dark">
                                        Votre première <span
                                        className="text-uppercase text-primary">protection</span> est à portée de main.
                                    </h3>
                                    {errorMessage && <Alert type="error">{errorMessage}</Alert>}
                                    {
                                        <Formik
                                            initialValues={{
                                                email: datas?.user?.email ?? "",
                                                emailConfirm: datas?.user?.email || "",
                                                phoneNumber: datas?.user?.phoneNumber || "",
                                            }}
                                            validationSchema={Yup.object({
                                                email: Yup.string()
                                                    .email("L'email n'est pas valide.")
                                                    .min(5, "L'email doit contenir au moins 5 caractères.")
                                                    .max(100, "L'email ne peut pas dépasser 100 caractères.")
                                                    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "L'email doit être valide.")
                                                    .required("L'email est requis."),
                                                emailConfirm: Yup.string()
                                                    .oneOf([Yup.ref("email")], "Les emails ne correspondent pas.")
                                                    .required("Veuillez confirmer votre email."),
                                                phoneNumber: Yup.string()
                                                    .matches(/^([0-9][0-9]{8,9})$/, "Numéro de téléphone invalide")
                                                    .required("Le téléphone est requis"),
                                            })}
                                            onSubmit={(values) => {
                                                setDatas({ ...datas, user: {...datas?.user ,...values} });
                                                checkEmailExistance(values.email, values.phoneNumber).then(r => {});
                                            }}>
                                            {(formik) => (
                                                <Form className="w-100 h-100 d-flex flex-column align-items-center justify-content-between">
                                                    <div>
                                                        <p className="mb-2">Renseignez vos informations personnelles</p>
                                                        <Input
                                                            onChange={formik.handleChange}
                                                            value={formik.values.email}
                                                            onBlur={formik.handleBlur}
                                                            required={true}
                                                            placeholder="Email"
                                                            name="email"
                                                            type="email"
                                                            errorMessage={formik.touched.email && formik.errors.email ? formik.errors.email : ""}
                                                        />
                                                        <Input
                                                            onChange={formik.handleChange}
                                                            value={formik.values.emailConfirm}
                                                            onBlur={formik.handleBlur}
                                                            required={true}
                                                            placeholder="Confirmation d'email"
                                                            name="emailConfirm"
                                                            type="email"
                                                            errorMessage={formik.touched.emailConfirm && formik.errors.emailConfirm ? formik.errors.emailConfirm : ""}
                                                        />

                                                        <div className="d-flex gap-1 align-items-end">
                                                            <IndicatifPhone
                                                                setPhonePrefix={setPhonePrefix}
                                                                value={phonePrefix}
                                                            />
                                                            <Input
                                                                placeholder="Numéro de téléphone"
                                                                name="phoneNumber"
                                                                type="text"
                                                                onChange={formik.handleChange}
                                                                value={formik.values.phoneNumber}
                                                                onBlur={formik.handleBlur}
                                                                required={true}
                                                                errorMessage={
                                                                    formik.touched.phoneNumber && formik.errors.phoneNumber ? formik.errors.phoneNumber : ""
                                                                }
                                                            />
                                                        </div>
                                                        <div
                                                            className={`mt-1 d-flex justify-content-${!steps[0].isCurrent ? "between" : "end"} w-100`}>
                                                            {!steps[0].isCurrent && (
                                                                <Button
                                                                    disabled={isLoading}
                                                                    label={"Retour"}
                                                                    onClick={() => handlePreviousStep()}
                                                                    style={Button_Style.OUTLINED}
                                                                />
                                                            )}
                                                            <Button
                                                                isLoader={isLoading}
                                                                buttonType={"submit"}
                                                                label={"Suivant"}
                                                                disabled={(!formik.isValid && formik.dirty) || isLoading}
                                                            />
                                                        </div>
                                                    </div>

                                                </Form>
                                            )}
                                        </Formik>
                                    }
                                    <TermsAgreement/>
                                </div>
                            </>
                        )}


                        {steps[2].isCurrent && (
                            <>
                                {datas && (
                                    <StripePaymentCard
                                        title={`${datas?.chosenPlan?.head} ${datas?.chosenPlan?.title}`}
                                        link={`${user?.type === 'partner' ? 'professionnels' : 'particuliers'}/id-assistant`}
                                        setDatas={setDatas}
                                        datas={datas}
                                        steps={steps}
                                        handlePaymentResult={handlePaymentResult}
                                        handlePreviousStep={handlePreviousStep}
                                        isMonth={isMonth}
                                    />
                                )}
                            </>
                        )}
                        {steps[3].isCurrent && (
                            <ResultAfterPayment
                                title={title}
                                message={message}
                                pageSucceeded={paymentSucceeded}
                                steps={steps}
                                handlePreviousStep={handlePreviousStep}
                                handleNextStep={handleGoToProfile}
                                textBtn={"Accéder à mon espace personnel"}
                                isLoading={isLoading}
                            />
                        )}

                    </div>
                    <div className="w-30 min-w-30">
                        <DocumentIllustration type={"payment"} />
                    </div>
                </div>

                {steps[2].isCurrent && (
                    <>
                        <br/> <br/> <br/>
                    </>
                )}
                <Footer />
            </div>
        </>
    );
};

export default SouscriptionPage;
